/* unplugin-vue-components disabled */import script from "./layout2.vue?vue&type=script&setup=true&lang=js"
export * from "./layout2.vue?vue&type=script&setup=true&lang=js"

import "./layout2.vue?vue&type=style&index=0&id=58e7ff90&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e7ff90"]])

export default __exports__